<template>
    <div
        :class="{ 'has-pack': petPackInCart }"
        class="cz2__pet-pack"
    >
        <div class="cz2__pet-pack-wrapper">
            <div class="cz2__pet-pack-image" />

            <div class="cz2__pet-pack-info-wrapper">
                <h2 class="cz2__pet-pack-title">
                    <img
                        v-if="petPackInCart"
                        src="../assets/icons/check-black.svg"
                        width="16"
                        height="12"
                        aria-hidden="true"
                    >
                    {{ petPackTitleCopy }}
                </h2>

                <p class="cz2__pet-pack-copy">
                    {{ $t('PET_PACK_COPY') }}
                </p>

                <div class="cz2__pet-pack-buttons">
                    <pet-pack-add-remove-button :hide-icon-mobile="true" />

                    <btn
                        :secondary="!petPackInCart"
                        @click="showInfoModal"
                    >
                        {{ $t('PET_PACK_DETAILS') }}
                    </btn>
                </div>
            </div>
        </div>

        <div class="cz2__pet-pack-buttons-mobile">
            <pet-pack-add-remove-button />

            <btn
                :secondary="!petPackInCart"
                @click="showInfoModal"
            >
                {{ $t('PET_PACK_DETAILS') }}
            </btn>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__pet-pack {
            margin: 16px;
            border-radius: 16px;
            padding: 16px;
            display: flex;
            flex-direction: column;
            background-color: color(v2BlueLight);
            font-family: 'Proxima Nova', sans-serif;
            max-width: 850px;

            .cz2__pet-pack-wrapper {
                width: 100%;
                display: flex;

                .cz2__pet-pack-image {
                    width: 45%;
                    background-image: url(../assets/images/branded/pokemon/buddy-pack-placeholder.png);
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center;
                }
            }

            .cz2__pet-pack-info-wrapper {
                width: 55%;
            }

            .cz2__pet-pack-title {
                margin-bottom: 8px;
                font-size: 20px;
                font-weight: 800;
                // Prevent card height jumping when copy changes
                min-height: 50px;
            }

            .cz2__pet-pack-copy {
                margin-bottom: 12px;
                font-size: 15px;
            }

            .cz2__pet-pack-buttons-mobile {
                width: 100%;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                gap: 8px;
            }

            .cz2__pet-pack-buttons {
                display: none;
            }

            .cz2__btn,
            .cz2__pet-pack-add-remove-button {
                flex-grow: 1;
                height: 40px;

                &:hover {
                    font-size: 16px;
                }
            }

            .cz2__btn--secondary {
                background-color: white;
            }

            @include respond-above(sm) {
                flex-direction: row;
                padding: 24px;

                .cz2__pet-pack-buttons-mobile {
                    display: none;
                }

                .cz2__pet-pack-buttons {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                }
            }
        }
    }
</style>

<script>
    import PetPackAddRemoveButton from './PetPackAddRemoveButton.vue';
    import Btn from './ui/Btn.vue';

    export default {
        components: {
            PetPackAddRemoveButton,
            Btn,
        },

        data() {
            return {
            };
        },

        computed: {
            petPackInCart() {
                return this.$store.getters.petPackInCart;
            },

            petPackTitleCopy() {
                return this.petPackInCart ? this.$t('PET_PACK_TITLE_ADDED') : this.$t('PET_PACK_TITLE');
            },
        },

        methods: {
            showInfoModal() {
                this.$store.dispatch('showPetPackInfoModal', true);
            },
        },
    };
</script>
